<template>
  <div
    class="vx-card mol-card-interaction aisea-p-7 aisea-pb-7 aisea-pl-9 aisea-pr-9 aisea-rounded-2"
    :class="{ selected: isSelected }"
    @click="jumpToPlot(plot)"
  >
    <vs-row vs-type="flex" vs-justify="center" vs-align="center">
      <vs-col vs-w="2">
        <img class="icon-size" :src="img" />
      </vs-col>

      <vs-col vs-w="10">
        <div class="aisea-text-16-600-white card-content truncate">
          {{ title }}
        </div>
        <div class="plot-range-datetime">
          <vs-row
            class="card-content"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
          >
            <vs-col class="aisea-text-12-600-white" vs-w="3">開始</vs-col>
            <vs-col
              class="aisea-text-12-300-white aisea-pl-3 truncate"
              vs-w="9"
            >
              <span>
                {{ startDate }}
              </span>
            </vs-col>
          </vs-row>
          <vs-row
            class="card-content"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
          >
            <vs-col class="aisea-text-12-600-white" vs-w="3">終了</vs-col>
            <vs-col
              class="aisea-text-12-300-white aisea-pl-3 truncate"
              vs-w="9"
            >
              <span>
                {{ endDate }}
              </span>
            </vs-col>
          </vs-row>
        </div>
      </vs-col>
      <vs-col vs-w="3" vs-justify="flex-end" vs-type="flex"> </vs-col>
    </vs-row>
  </div>
</template>

<script>
/**
 * プライベートプロットカード一つを描画するコンポーネント
 * @parent O.PrivatePlot
 * @props plot: Object プロットの詳細データの一つ
 * @props jumpToPlot: プロット選択時にvuexの追跡情報とFireStoreの追跡情報を更新する関数
 * @props isSelected: Boolean 現在の選択状態を管理
 */
import { PLOT_CHILD_CATEGORY } from "@/config/const";
import moment from "moment";

export default {
  name: "M.PrivatePlotCard",
  props: {
    plot: {
      type: Object,
      default: null,
    },
    jumpToPlot: {
      type: Function,
      required: true,
    },
    isSelected: {
      type: Boolean,
    },
  },
  data() {
    return {
      defaultValues: {
        noneDate: "---",
        noneText: "",
      },
    };
  },
  computed: {
    // タイトル
    title() {
      if (!this.plot) return this.defaultValues.noneText;
      return this.plot.title ? this.plot.title : this.defaultValues.noneText;
    },
    // 開始日時
    startDate() {
      if (!this.plot) return this.defaultValues.noneDate;
      if (!this.plot.start_date) return this.defaultValues.noneDate;
      return this.plot.start_date.seconds != null
        ? moment(this.plot.start_date.seconds * 1000).format("YYYY/MM/DD HH:mm")
        : this.defaultValues.noneDate;
    },
    // 終了日時
    endDate() {
      if (!this.plot) return this.defaultValues.noneDate;
      if (!this.plot.end_date) return this.defaultValues.noneDate;
      return this.plot.end_date.seconds != null
        ? moment(this.plot.end_date.seconds * 1000).format("YYYY/MM/DD HH:mm")
        : this.defaultValues.noneDate;
    },
    // アイコン
    img() {
      if (!this.plot) return this.defaultValues.noneText;
      if (!this.plot.plot_child_category_id) return this.defaultValues.noneText;
      return require("@/assets/images/plot/" +
        PLOT_CHILD_CATEGORY.properties[this.plot.plot_child_category_id].img +
        ".png");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.vx-card {
  cursor: pointer;
  width: 360px;
  height: 100px;
  margin: 0 auto;

  .icon-size {
    height: 2rem;
  }

  .card-content {
    margin-bottom: 3px;
  }
}

.mol-card-interaction {
  background-color: $aisea-blue-gray;

  &:hover {
    background-color: #6a717d;
  }

  &:active {
    background-color: #969ba4;
  }
}

.mol-card-interaction.selected {
  background-color: #1b5e83;
  outline: 2px solid #2d9cdb;

  &:hover {
    background-color: #588eac;
  }

  &:active {
    background-color: #98b6c7;
  }
}
</style>
